import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PermissionService } from "../permission.service";

@Injectable({
  providedIn: "root",
})
export class FlowsListGuard implements CanActivate {
  constructor(
    private PermissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return from(this.PermissionService.categories.logicTrees.hasList()).pipe(
      map((res) => {
        if (!res) {
          this.router.navigate([""]);
        }
        return res;
      }),
    );
  }
}

@Injectable({
  providedIn: "root",
})
export class FlowsWriteGuard implements CanActivate {
  constructor(
    private PermissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return from(this.PermissionService.categories.logicTrees.hasWrite()).pipe(
      map((res) => {
        if (!res) {
          this.router.navigate([""]);
        }
        return res;
      }),
    );
  }
}

@Injectable({
  providedIn: "root",
})
export class FlowsReportGuard implements CanActivate {
  constructor(
    private PermissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return from(this.PermissionService.categories.logicTrees.hasReport()).pipe(
      map((res) => {
        if (!res) {
          this.router.navigate([""]);
        }
        return res;
      }),
    );
  }
}
